export const register = "register"
export const login = "login"
export const logout = "logout"
export const deleteAccount = "delete_account"
export const getSettings = "settings"
export const getCity = "city"
export const getShop = "shop"
export const getBrands = "brands"
export const getCategory = "categories"
export const getSlider = "sliders"
export const getOffer = "offers"
export const getSection = "sections"
export const getUser = "user_details"
export const editProfile = "edit_profile"
export const getProducts = "products"
export const getProductById = "product_by_id"
export const getCart = "cart"
export const getCartCount = "get_cart_count"
export const getFavorite = "favorites"
export const getAddress = "address"
export const getTimeSlot = "time_slots"
export const placeOrder = "place_order"
export const deleteOrder = "deletenve_order"
export const getOrders = "orders"
export const getPaymentMethods = "payment_methods"
export const getTransactions = "get_user_transactions"
export const getInvoices = "invoice_download"
export const addTransaction = "add_transaction"
export const initiateTrasaction = "initiate_transaction"
export const getNotification = "notifications"
export const getFaq = "faqs"
export const getPromoCode = "promo_code"
export const setPromoCode = "validate"
export const getSystemLanguage = "system_languages"
export const updateOrderStatus = "update_order_status"
export const getProductRatings = "ratings_list"
export const rating = "rating"
export const getShopBySellers = "sellers"
export const getShopByCountries = "countries"
export const getShopByBrands = "brands"
export const imageList = "image_list"
export const getGuestCart = "guest_cart"
export const bulkAddToCart = "bulk_add_to_cart_items"
export const checkUserExists = "verify_user"
export const sendSms = "send_sms"
export const verifyContact = "verify_user"

export const remove = "remove"
export const add = "add"
export const deleteItem = "delete"
export const update = "update"
export const edit = "edit"